<script>
    import { syncDelay } from "../script/common";
    import { SPort, generateBinChannel } from "../script/store";

    // TODO  import broken
    const PORT_STATE = Object.freeze({
        DISCONNECTED_NO_REF: {
            // NOT USED
            text: "Disconnected",
            color: "grey",
        },
        DISCONNECTED_REF: {
            text: "Disconnected",
            color: "red",
        },
        CONNECTED_NOT_ACT: {
            text: "Inactive",
            color: "yellow",
        },
        CONNECTED_ACT: {
            text: "Active",
            color: "green",
        },
    });

    let serialDisabled = !serialAvalible(); // TO DO
    const constantSerialPort = [];
    let dinamickSerialPort = constantSerialPort;
    let activePort = null;

    function addDevice(device) {
        constantSerialPort.push(device);
        updateDevices();
    }
    function removeDevice(device) {
        const index = constantSerialPort.indexOf(device);
        if (index !== -1) {
            constantSerialPort.splice(index, 1);
            updateDevices();
        }
    }
    function updateDevices() {
        dinamickSerialPort = [...constantSerialPort];
    }
    function serialAvalible() {
        return navigator.serial ? true : false;
    }
    /* function conectionDestruction(connectionState) {
        connectionState.Writer.close();
        connectionState.Reader.cancel();
        connectionState.Device.close();
    } */

    async function search() {
        try {
            const filters = [
                { usbVendorId: 403, usbProductId: 6001 },
                { usbVendorId: 1027, usbProductId: 24577 },
                { usbVendorId: 6790, usbProductId: 29987 },
                { usbVendorId: 10755, usbProductId: 67 },
            ];

            const port = await navigator.serial.requestPort(
                { filters } // DEV
            );
            window.p = port; // DEV
            for (let i = 0; i < constantSerialPort.length; i++) {
                if (port === constantSerialPort[i].device.ref) {
                    console.log(
                        "Port already exist, connection to existing port."
                    );
                    setActive(constantSerialPort[i]);
                    return;
                }
            }

            connect(port);
        } catch (err) {
            console.warn(err.message, err); // TO DO - display not connected port
        }
    }
    async function connect(port) {
        await port.open({ baudRate: 9600 });

        const connectionState = {
            ref: port,
            conected: false,
            write: null,
            writerSubscription: null,
            reader: null,
        };

        const serialPortDescriptor = {
            name: "Port " + (constantSerialPort.length + 1),
            state: PORT_STATE.CONNECTED_NOT_ACT,
            device: connectionState,
        };
        // port.ondisconnect // TO DO, api unsuperted?
        addDevice(serialPortDescriptor);
        setActive(serialPortDescriptor);
    }
    /* function hardDisconnect(port) {
        console.log("[INFO]: Serial reader disconnected");
        // if (device.writerSubscription) device.writerSubscription(); // DUP
        setInWaiting(port);
        serialPortDescriptor.state = PORT_STATE.DISCONNECTED_REF;
        updateDevices();
    } */
    async function setActive(portDescriptor) {
        if (!portDescriptor || portDescriptor.device.conected) return; // TO DO connected test beter
        setInWaiting(activePort); // reset state
        const device = portDescriptor.device;
        device.writer = device.ref.writable.getWriter();
        device.reader = device.ref.readable.getReader();
        device.conected = true;
        const portHandle = {
            meta: {
                name: portDescriptor.name,
                state: portDescriptor.state,
            },
            writerObs: generateBinChannel(),
            readerObs: generateBinChannel(),
        };
        const streamConsumer = async () => {
            const DEC = new TextDecoder();
            while (true) {
                try {
                    const { done, value } = await device.reader.read();
                    if (done) {
                        break;
                    } else {
                        // console.log("S-in ", DEC.decode(value));
                        portHandle.readerObs.send(value);
                    }
                } catch (err) {
                    console.log("[INFO]: Serial reader disconnected");
                    await setInWaiting(portDescriptor, false);
                    portDescriptor.state = PORT_STATE.DISCONNECTED_REF;
                    updateDevices();
                    await syncDelay(500); // TO DO - not neaded
                    removeDevice(portDescriptor)
                    break;
                }
            }
        };
        streamConsumer();
        const buffer = [];
        device.writerSubscription = portHandle.writerObs.subscribe((data) => {
            if (!data) return;
            const sendEnable = buffer.length === 0;
            for (let i = 0; i < data.length; i++) {
                buffer.push(data[i]);
            }
            if (sendEnable) {
                const shiftArr = () => {
                    const sVal = buffer.shift();
                    const sBuf = new Uint8Array([sVal]);
                    //console.log("S-out", sBuf);
                    device.writer.write(sBuf);
                    if (buffer.length !== 0) {
                        setTimeout(shiftArr, 5);
                    }
                };
                setTimeout(shiftArr, 5);
            }
        });

        await syncDelay(500); // DEV
        activePort = portDescriptor;
        portHandle.meta.state = PORT_STATE.CONNECTED_ACT;
        SPort.connect(portHandle);
        portDescriptor.state = PORT_STATE.CONNECTED_ACT;
        updateDevices();
    }
    async function setInWaiting(portDescriptor, updateList = true) {
        try {
            if (!portDescriptor) return;
            const device = portDescriptor.device;
            if (device.conected) {
                if (device.writer) device.writer.close(); // TO DO do not close closed
                if (device.reader) device.reader.cancel();
                device.conected = false;
            }
            if (device.writerSubscription) {
                device.writerSubscription(); // DUP
                device.writerSubscription = null;
            }
            portDescriptor.state = PORT_STATE.CONNECTED_NOT_ACT;
            SPort.disconect();
            if (updateList) {
                updateDevices();
            }
        } catch (err) {
            console.warn("Can not cleanly exit connection", err);
        }
    }
    function disconnectGenerator(portDescriptor) {
        return () => {
            setInWaiting(portDescriptor);
        };
    }
    function reconnectGenerator(portDescriptor) {
        return () => {
            setActive(portDescriptor);
        };
    }
</script>

<div id="wikaSetting">
    <div class="portList">
        {#if dinamickSerialPort.length === 0}
            Nepřipojeno
        {/if}
        {#each dinamickSerialPort as port}
            <div class="port">
                <span class="portHeader">
                    {port.name}
                </span>
                <span class="portState">
                    {port.state.text}
                    <span
                        class="material-icons"
                        style={"color: " + port.state.color}
                    >
                        brightness_1
                    </span>
                </span>
                {#if port.state === PORT_STATE.CONNECTED_ACT}
                    <button
                        class="standartButtonGrey"
                        on:click={disconnectGenerator(port)}
                    >
                        Odpojit
                    </button>
                {:else}
                    <button
                        class="standartButtonGrey"
                        on:click={reconnectGenerator(port)}
                    >
                        Znovu Připojit
                    </button>
                {/if}
            </div>
        {/each}
    </div>
    <button class="standartButton" on:click={search}>Vyhledat nový</button>
</div>

<style>
    .portList {
        display: flex;
        padding: 1rem 2rem;
    }
    .port {
        border: solid var(--back_D2) 1px;
        background: #fdfdfd;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .portHeader {
        font-size: 1.5em;
        font-weight: 300;
    }
    .portState {
        display: flex;
        align-items: center;
        margin: 0.5rem;
    }
    .portState .material-icons {
        margin-left: 0.3rem;
    }
    .standartButtonGrey {
        background: var(--prim);
        color: white;
        font-weight: 700;
        padding: 0.4em 0.8em;
        font-size: 0.9rem;
        margin: 0.5rem;
        margin-bottom: 0;
    }
</style>
